import React from "react";

const styles = {
  Active:   "bg-emerald-100 text-emerald-800 border-emerald-300",
  Regular:  "bg-emerald-100 text-emerald-800 border-emerald-300",
  Received: "bg-emerald-100 text-emerald-800 border-emerald-300",
  Pending:  "bg-amber-100 text-amber-800 border-amber-300",
  Overdue:  "bg-rose-100 text-rose-800 border-rose-300",
  Paid:     "bg-emerald-100 text-emerald-800 border-emerald-300",
  Partially:"bg-amber-100 text-amber-800 border-amber-300",
  Unpaid:   "bg-slate-100 text-slate-700 border-slate-300",
  Reversed: "bg-rose-50 text-rose-700 border-rose-300 line-through",
  Queued:   "bg-sky-50 text-sky-800 border-sky-300",
  Sent:     "bg-teal-50 text-teal-800 border-teal-300",
  Delivered:"bg-emerald-100 text-emerald-800 border-emerald-300",
  Failed:   "bg-rose-100 text-rose-800 border-rose-300",
  Cancelled:"bg-slate-100 text-slate-600 border-slate-300",
  Closed:   "bg-slate-100 text-slate-700 border-slate-300",
};

export const StatusBadge = ({ status }) => {
  const key = typeof status === "string" ? status.split(" ")[0] : "Closed";
  const cls = styles[key] || styles.Closed;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold ${cls}`}>
      {status}
    </span>
  );
};
